import React from "react"
import { PAGE_DATA_URL_PREFIX } from "../../helpers/helper"
import parse from 'html-react-parser';

const CustomProductIntro = ({ src, title, description }) => {
  return (
    <div>
      <img src={PAGE_DATA_URL_PREFIX + src} alt="" className="w-full max-w-full h-auto" />
      <div className="mt-4">
        <p className="product-intro-title">{title}</p>
        <p className="product-intro-description mt-4 px-5">{parse(description)}</p>
      </div>
    </div>
  )
}

export default CustomProductIntro
